<template>
  <div>
    <div class="ptt-container">
      <button class="ptt-button" :class="{ 'is-active': isPopoverOpen }" @click="togglePopover">
        <span class="icon"><img :src="icon" /></span>
      </button>

      <div v-if="isPopoverOpen" ref="" class="ptt-popover">
        <Controls @send-recording="handleSendRecording" />
        <HistoricSummary :historic-open.sync="isHistoricOpen" />
      </div>
    </div>
    <Historic :open.sync="isHistoricOpen" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import icon from "./icon.svg";
import Controls from "./Controls.vue";
import HistoricSummary from "./HistoricSummary.vue";
import { uploadPushToTalk } from "../utils/s3";
import { PttTargetType, RecordingData } from "../types";
import { useMessage } from "@/utils/useMessage";
import Historic from "./Historic.vue";

const message = useMessage();
const isPopoverOpen = ref<boolean>(false);
const isHistoricOpen = ref<boolean>(false);

const togglePopover = (): void => {
  isPopoverOpen.value = !isPopoverOpen.value;
};

const handleSendRecording = async ({ wgId, centralId, audio, target, taxiId }: RecordingData) => {
  try {
    await uploadPushToTalk(
      wgId,
      centralId,
      {
        type: target === "taxi" ? PttTargetType.TAXI : PttTargetType.FLEET,
        id: target === "taxi" ? taxiId : undefined,
      },
      audio
    );
    isPopoverOpen.value = false;
    message.success("Audio enviado correctamente");
  } catch (error) {
    message.error("No se pudo enviar el audio. Inténtalo otra vez.");
    console.error(error);
  }
};
</script>

<style scoped lang="scss">
.ptt-container {
  position: relative;
}

.ptt-button {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  color: white;
  background-color: $menuBg2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.ptt-button .icon {
  margin-top: 4px;
}

.ptt-popover {
  z-index: 1000;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 1rem;
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 200px;
}
</style>
